import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useEntityCrud } from '../../hooks/useEntityCrud';

const DEFAULT_FORM = {
    title: ""
}

const SupportPhone = () => {

    const [form, setForm] = useState(DEFAULT_FORM)

    const { addData: addConfig } = useEntityCrud("Config/update")
    const { readData } = useEntityCrud('Config/get');


    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        const body = {
            "key": "support_phone"
        }
        readData(body).then(({ data }) => {
            if (data.status)
                setForm({
                    title: data.result?.value
                })
        });
    }


    const handleChange = (e) => {
        const newForm = { ...form };
        newForm[e.target.name] = e.target.value
        setForm(newForm)
    }

    function handleSubmit(e) {
        debugger
        e.preventDefault();
        const body = {
            "value": form.title,
            "key": "support_phone"
        }
        addConfig(body)
            .then(({ data }) => {
                debugger
                if (data.status) {
                    toast.success('عملیات مورد نظر با موفقیت انجام شد');
                }
            })
    }



    return (
        <div className=" baseInfo_" >
            <form onSubmit={handleSubmit} >
                <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>
                    <div className="col-md-4 pr-0">
                        <div className="form-group ">
                            <label>  شماره تماس پشتیبانی  </label>
                            <input value={form.title} name={"title"} onChange={handleChange} type="tel" maxLength={11} dir='ltr'
                                className="form-control mt-0 ltr-input " />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group mb-0">
                            <button className="btn btn-success px-4 btn-block">ذخیره اطلاعات </button>
                        </div>
                    </div>
                </div>ّ
            </form>
        </div>
    );
}

export default SupportPhone;